// export const API_URL = "https://access-api-dev.gettradeslink.com/api/v1/" /** Dev API */
export const API_URL = "https://access-api.gettradeslink.com/api/v1/" /** Production API */
// export const API_URL = "http://127.0.0.1:8000/api/v1/" /** Local API */
export const GOOGLE_API_KEY = "AIzaSyADoEd1zoZsMnn8AuJ3InabTCCnMixR04c"
